import { $analyticalMixingSearchStore, updateAnalyticalMixingSearchStore } from '@/modules/mixing/store/analytical-mixing.store';
import { useStore } from 'effector-react';
import { useState } from 'react';

export const useManualMixing = (mockStores: { id: number, label: string, checked: boolean}[]) => {
  
  const initialState: ISearchByParams = {
    stores: mockStores ?? [],
    permissibleVariation: '',
    gluten: '',
    idk: '',
    protein: '',
    humidity: '',
    natura: '',
    fallingNumber: '',
    temperature: '',
  };

  const value = useStore<ISearchByParams>($analyticalMixingSearchStore);

  const setValue = updateAnalyticalMixingSearchStore;

  //const [value, setValue] = useState(initialState);

  const setStores = (stores: IStore[]) =>
    setValue({ ...value, stores: stores });

    const setPermissibleVariation = (variation: number | string) =>
    setValue({ ...value, permissibleVariation: variation });

  const setGluten = (glutenValue: number | string) =>
    setValue({ ...value, gluten: glutenValue });

  const setIdk = (idkValue: number | string) =>
    setValue({ ...value, idk: idkValue });

  const setProtein = (proteinValue: number | string) =>
    setValue({ ...value, protein: proteinValue });

  const setHumidity = (humidityValue: number | string) =>
    setValue({ ...value, humidity: humidityValue });

  const setNatura = (naturaValue: number | string) =>
    setValue({ ...value, natura: naturaValue });

  const setFallingNumber = (fallingNumberValue: number | string) =>
    setValue({ ...value, fallingNumber: fallingNumberValue });

  const setTemperature = (temperatureValue: number | string) =>
    setValue({ ...value, temperature: temperatureValue });

  const setInitialState = () => setValue(initialState);

  return {
    value,
    setValue,
    setStores,
    setPermissibleVariation,
    setGluten,
    setIdk,
    setProtein,
    setHumidity,
    setNatura,
    setFallingNumber,
    setTemperature,
    setInitialState,
    initialState,
  };
};

export interface ISearchByParams {
  stores: IStore[];
  permissibleVariation: string | number;
  gluten: string | number;
  idk: string | number;
  protein: string | number;
  humidity: string | number;
  natura: string | number;
  fallingNumber: string | number;
  temperature: string | number;
}

export interface IStore {
  id: number;
  label: string;
  checked: boolean;
}
